//TODO: Move constants from server folder to here so that we can use the same constants across both server and client directory
export {}

export const CONSUMER = 'consumer'
export const MERCHANT = 'merchant'
// min characters required for search
export const MIN_LENGTH_SEARCH_CHAR = 2
// max characters required for search
export const MAX_LENGTH_SEARCH_CHAR = 60
export const PERSONAL = 'personal'
export const BUSINESS = 'business'
